<template>
  <section v-if="page" class="overflow-x-auto " :class="page.padding && [config.padding[page.padding]]">
    <cms-section v-for="section in page.sections" :key="section.name" :section />
  </section>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  'change-page-title': [title: string]
}>()

const route = useRoute()
const config = useAppConfig().pages.cms
const slug = useRouteParams<string>('slug')
const childSlug = useRouteParams<string>('child_slug')
const { getUserEventData } = useAnalytics()
const { monetateConfig } = useFeatureFlags()
const { $gtm, $sendExtraMonetateEvents } = useNuxtApp()
const { getPage, getSeoMetadata } = useCms()
const cart = useCartStore()

const localisedHelp = useLocalisedPath('/help')
const page = await getPage(`${localisedHelp.substring(1)}/${slug.value}/${childSlug.value}`)

if (page) {
  const { metadata, link } = getSeoMetadata(page)
  useSeoMeta(metadata)
  useHead(() => ({ link }))

  emit('change-page-title', metadata.title)
}

// defines markup via unhead-schema for search functionality on homepage
// https://unhead-schema-org.harlanzw.com/guide/getting-started/how-it-works
useSchemaOrg([
  defineWebSite({
    potentialAction: [
      defineSearchAction({
        target: '/search?q={search_term_string}'
      })
    ]
  })
])

onMounted(async () => {
  $gtm.push('page.onLoadPageData', route, {
    pageTitle: await getPageTitle(),
    pageCategory: 'Content',
    pageName: page?.name
  })
  const mainSlug = slug.value?.[0]
  if (monetateConfig?.extraMonetateEventsPages?.includes(mainSlug) || !mainSlug)
    $sendExtraMonetateEvents()

  $gtm.push('user.onLoadUserData', await getUserEventData())
  $gtm.push('page.onRouterChange', route)
  $gtm.push('cart.onCartLoad', cart)
})
</script>
